<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{}"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:defaultImgUrl="{ row }">
        <b-avatar
          :src="row.scoreImgUrl ? $osscdn(row.scoreImgUrl) : ''"
        ></b-avatar>
        <span class="ml-3">{{ row.scoreByName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip effect="dark" content="查看" placement="top">
          <i
            style="font-size:30px"
            class="el-icon-view"
            @click="showDetail(row.visitScoreCode)"
          ></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
    <!--编辑弹框-->
    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :close-on-click-modal="false"
      width="800px"
    >
      <score-detail :visitScoreCode="formOption.code"></score-detail>
    </el-dialog>
  </div>
</template>
<script>
export default {
  components: {
    ScoreDetail: () => import('./score-detail.vue')
  },
  props: {
    code: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      loading: false,
      formOption: {
        title: '',
        dialogFormVisible: false,
        code: ''
      },
      tableHeight: 343,
      tableData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: this.reload
        },
        zoom: true,
        custom: true
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          type: 'seq'
        },
        {
          field: 'scoreImgUrl',
          width: 200,
          title: '评分人',
          slots: { default: 'defaultImgUrl' }
        },
        {
          field: 'scoreTime',
          width: 180,
          title: '评分时间'
        },
        {
          field: 'score',
          width: 150,
          align: 'center',
          title: '得分'
        },
        {
          field: 'appraisalBillName',
          minWidth: 300,
          title: '评分模板'
        },
        {
          field: 'col-opt',
          title: '操作',
          align: 'center',
          width: 200,

          slots: {
            default: 'opt'
          }
        }
      ]
    }
  },
  watch: {
    code: {
      handler() {
        this.loadData()
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //加载数据
    loadData() {
      this.loading = true
      this.$api
        .opaScmVisitscoreGetVisitScoreListApi({ visitCode: this.code })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    showDetail(visitScoreCode) {
      this.formOption.code = visitScoreCode
      this.formOption.title = '评分记录'
      this.formOption.dialogFormVisible = true
    }
  }
}
</script>
<style lang="scss" scoped>
.fabric-tree {
  height: 550px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px; /*滚动条宽度*/
  }
}
</style>
